module.exports = __webpack_public_path__ + "static/media/liftoff-hor-fr.485517cb.png";